const Store = {
  set(key, value, storage = window.localStorage) {
    storage.setItem(key, JSON.stringify(value));
  },
  get(key, storage = window.localStorage) {
    const value = storage.getItem(key);
    if (value === void 0 || value === null) {
      return void 0;
    }
    try {
      return JSON.parse(value);
    } catch (_e) {
      return value;
    }
  },
  delete(key, storage = window.localStorage) {
    storage.removeItem(key);
  },
  sessionSet(key, value) {
    return Store.set(key, value, window.sessionStorage);
  },
  sessionGet(key) {
    return Store.get(key, window.sessionStorage);
  },
  sessionDelete(key) {
    return Store.delete(key, window.sessionStorage);
  }
};
export default Store;
